// toastUtil.js
import { toast } from 'react-toastify';

export function notify(type, message, options = {}) {
  const toasters = {
    success: toast.success,
    error:   toast.error,
    info:    toast.info,
    warning: toast.warn,
    default: toast,
  };
  (toasters[type] || toast)(message, options);
}
